goog.provide('el8.app.shared.userHeadlines');

goog.require('el8.app.pageLayout');
goog.require('el8.appservice.headline');
goog.require('el8.service.pageunload');
goog.require('el8.service.urls');
goog.require('el8.template.app.shared.userHeadlines');
goog.require('el8.tourguide.passportPhysicianSplash');
goog.require('el8.util.base');
goog.require('el8.util.amplitude.helpers')


/**
 * This file manages dismissable banners sent down by the server
 * for support messages, new feature rollouts, etc.
 *
 * When creating a new headline with a trigger, give the link the class
 * "headline-trigger" and a data-name corresponding to the entry in clickMap below.
 * For more details on the implementation, see headline.js
 */
el8.app.shared.userHeadlines = (function() {

    /* We want to turn this on/off depending on page, and
     * whether user asks to suppress.
     *
     * Defaults to OFF. Currently this only gets run by
     * app/setup.js, so any pages that don't run app/setup.js
     * (e.g. printouts) do not have this turned on.
     */
    var _isEnabled = false;

    var _hlines = [];
    var _headline = null;
    var _container = null;

    var _viewed = {};
    var _displayedIndex = null;

    var that = {};

    /*************
     * Click map
     *************/
    var clickMap = {
        'passport-ftue': function() {
            el8.tourguide.passportPhysicianSplash.show();
        }
    };

    /************************
     * Internal functions
     ************************/
    function _doShow(hlines) {

        if (!hlines.length) { return; }

        _headline = new el8.appservice.headline({
            wrapperId: 'page-user-headline',
            wrapperFn: el8.template.app.shared.userHeadlines.wrapper,
            contentFn: el8.template.app.shared.userHeadlines.content,
            clickMap: clickMap,
            placement: 'below'
        });

        _container = _headline.show({
            wrapperFn: el8.template.app.shared.userHeadlines.wrapper,
            contentFn: el8.template.app.shared.userHeadlines.content
        });

        _setHeadlines(hlines);
        that.display();

        _container.on('click', '.dismiss-trigger',  function(e) {
            var curIndex = _getDisplayedIndex();
            if (_hlines[curIndex]) {
                var hline = _hlines[curIndex]
                el8.util.amplitude.logEvent('dismiss banner', {
                  'message id': hline.id,
                  'banner copy': hline.message
                })
                markAsViewed(hline.id); // mark current headline viewed
            } else {
                UIM && UIM.logError('Error trying to dismiss headlines.\ncurIndex: ' + curIndex + '\n _hlines: ' + JSON.stringify(_hlines));
            }
            acknowledgeAllViewed();

            that.disable();
            that.hide();

        }).on('click', '.prev-trigger',  function(e) {
            var index = $(this).data('index');
            _displayPrevious(index);

        }).on('click', '.next-trigger',  function(e) {
            var index = $(this).data('index');
            _displayNext(index);

        }).on('click', 'a[href]:not(.next-trigger, .prev-trigger, .dismiss-trigger, .headline-trigger)',  function(e) {
          var curIndex = _getDisplayedIndex();
          if (_hlines[curIndex]) {
              var hline = _hlines[curIndex]
              el8.util.amplitude.logEvent('click banner', {
                'message id': hline.id,
                'banner copy': hline.message,
                'redirect': e.target.href
              })
          }
        });
    }

    function _setHeadlines(hlines) {
        _hlines = hlines;
    }
    function _displayNext(index) {
        that.displayByIndex((index + 1) % _hlines.length);
    }
    function _displayPrevious(index) {
        that.displayByIndex((index + _hlines.length - 1) % _hlines.length);
    }

    function _getDisplayedIndex() {
        return (el8.util.isNone(_displayedIndex)) ? 0 : _displayedIndex;
    }

    function markAsViewed(id) {
        _viewed[id] = true;
    }

    /**
     * Do actual acknowledge of viewed messages
     */
    function acknowledgeAllViewed() {
        var emptyFn = function() {};
        for (var id in _viewed) {
            if (_viewed.hasOwnProperty(id)) {
                $.el8_ajax({
                    type: 'POST',
                    url: el8.service.urls.get('ackHeadlineMsg', [id]),
                    error_override: emptyFn
                });
            }
        }
    }

    /********************
     * External interface
     ********************/
    $.extend(that, {

        enable: function() { _isEnabled = true; },
        disable: function() { _isEnabled = false; },

        /**
         * Major show/hide methods
         */
        update: function(hlines) {
            if (!_isEnabled) { return; }
            if (!_headline) {
                _doShow(hlines);
            } else {
                if (hlines.length === 0) {
                    // the user dismissed these headlines in another tab -> hide
                    this.disable();
                    this.hide();
                } else if (hlines.length !== _hlines.length) {
                    // the index of our current item may have changed - find the new index
                    var displayedId = _hlines[_getDisplayedIndex()]['id'];
                    hlines.forEach(function(h, index) {
                        if (h.id === displayedId) {
                            _displayedIndex = index;
                            return;
                        }
                    });
                }
                _setHeadlines(hlines);

                this.display(false); // headlines already visible - no need to resize
            }
        },
        hide: function() {
            _headline.hide();
            _viewed = {};
        },
        display: function(triggerResize) {
            this.displayByIndex(_getDisplayedIndex(), triggerResize);
        },
        displayByIndex: function(index, triggerResize) {
            if (!_isEnabled) { return; }
            if (_hlines.length > index) {
                var hline = _hlines[index];
                $('.user-headlines-content', _container).html(
                    el8.template.app.shared.userHeadlines.entry({
                        hline: hline,
                        index: index,
                        total: _hlines.length
                    })
                );
                if (hline['message_type'] === 'API') {
                    _container.addClass('el8ApiSupportMessage');
                } else {
                    _container.removeClass('el8ApiSupportMessage');
                }
                _displayedIndex = index;
                triggerResize = (triggerResize !== false); // default true
                if (triggerResize) { el8.app.pageLayout.trigger('el8_resizeApp'); }
                markAsViewed(hline['id']);
            }
        }
    });

    return that;

})();
